<template>

  <div class="d-flex">
    <button
      type="button"
      class="btn btn-lg btn-linkedin"
      @click="open('linkedin')"><i class="fab fa-linkedin-in" /></button>
    <button
      type="button"
      class="btn btn-lg btn-facebook"
      @click="open('facebook')"><i class="fab fa-facebook-f" /></button>
    <button
      type="button"
      class="btn btn-lg btn-twitter"
      @click="open('twitter')"><i class="fab fa-twitter" /></button>
  </div>

</template>

<script>
export default {
  name: 'SocialShare',
  props: {
    url: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      popupInfo: {
        width: 626,
        height: 436
      }
    }
  },
  mounted () {
  },
  methods: {
    getTrackedUrl (url, source) {
      const parseUrl = new URL(url)
      parseUrl.searchParams.set('src', source)
      return parseUrl.href
    },
    open (social) {
      // source
      // https://github.com/nicolasbeauvais/vue-social-sharing/blob/master/src/networks.json
      if (social === 'facebook') {
        const url = this.getTrackedUrl(this.url, 'Facebook')
        this.popup(`https://www.facebook.com/sharer/sharer.php?u=${url}&title=${this.title}&description=${this.description}&quote=&hashtag=`, null)
      }
      if (social === 'linkedin') {
        const url = this.getTrackedUrl(this.url, 'LinkedIn')
        this.popup(`https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${this.title}&summary=${this.description}`, null)
      }
      if (social === 'twitter') {
        const url = this.getTrackedUrl(this.url, 'Twitter')
        this.popup(`https://twitter.com/intent/tweet?text=${this.title}&url=${url}&hashtags=`, null)
      }
    },
    /*
    popup
    */
    popup (url, title) {
      const w = this.popupInfo.width
      const h = this.popupInfo.height

      // Fixes dual-screen position, Most browsers, Firefox
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

      const systemZoom = width / window.screen.availWidth
      const left = (width - w) / 2 / systemZoom + dualScreenLeft
      const top = (height - h) / 2 / systemZoom + dualScreenTop
      const newWindow = window.open(url, title, `scrollbars=yes, width=${w / systemZoom}, height=${h / systemZoom}, top=${top}, left=${left}`)

      if (window.focus) newWindow.focus()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.d-flex > * {
  margin: 0 5px 0 0; 
}
.btn-linkedin{
  background: #3c86ad;
  border-color: #3c86ad;
  color: #ffffff;
  min-width: 50px;
}
  .btn-linkedin:hover{
    background: #316d8c;
  }
.btn-facebook{
  background: #5170a4;
  border-color: #5170a4;
  color: #ffffff;
  min-width: 50px;
}
  .btn-facebook:hover{
    background: #425b85;
  }
.btn-twitter{
  background: #4cb7eb;
  border-color: #4cb7eb;
  color: #ffffff;
  min-width: 50px;
}
  .btn-twitter:hover{
    background: #3f96c0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/SocialShare.vue